import type { CSSProperties, ReactNode } from 'react'
import { cmsEllipsis, cmsTextTitle } from '@/styles/cmsText'

/** Inner label span — ellipsis inside a fixed-size button/link */
export const BTN_LABEL_ELLIPSIS: CSSProperties = {
  display: 'block',
  flex: '1 1 auto',
  width: 0,
  minWidth: 0,
  maxWidth: '100%',
  textAlign: 'center',
  ...cmsEllipsis(),
}

export function buttonLabelTitle(children: ReactNode, title?: string): string | undefined {
  if (title) return cmsTextTitle(title)
  if (typeof children === 'string') return cmsTextTitle(children)
  return undefined
}
